<template>
  <div id="selectEmployee" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="catalogo"
    >
      <v-row no-gutters class="titulo catalogoTitle"
        >Administración de Empleados</v-row
      >

      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2"
          >¿La estructura organizacional será por?</v-col
        >
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="estructura" id="estructura" v-model="estructura">
            <option disabled value="0">Selecciona estructura</option>
            <option
              v-for="carga in structure"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2" v-if="estructura == 2"
          >Empresa Pagadora</v-col
        >
        <v-col cols="12" sm="4" class="py-2 selectGris" v-if="estructura == 2">
          <select name="pagadora" id="pagadora" v-model="enterprise">
            <option disabled value="0">Selecciona empresa</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">¿El tipo de carga?</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="location" id="location" v-model="carga">
            <option disabled value="0">Selecciona carga</option>
            <option
              v-for="carga in cargas"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <span class="fa-1x mr-2">
            <font-awesome-icon class="icondownload" icon="file-excel" />
          </span>
          <label class="textdownload">Descargar</label>plantillas de Excel áreas
        </v-col>

        <v-col
          cols="12"
          sm="12"
          class="uploadfile p-0 pb-0 pt-2"
          v-if="carga == 2"
        >
          Subir archivo de Excel con la lista de dato del empleado que desea
          actualizar
          <input
            type="file"
            id="archivo"
            lang="es"
            class="my-3"
            @change="previewFiles($event)"
          />
        </v-col>
        <v-col cols="12" sm="12" class="mt-3 pa-0" align-self="end">
          <button class="boton" @click="validacion()">Siguiente</button>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>

    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="lista"
    >
      <v-row no-gutters class="titulo catalogoTitle">Alta de Empleado</v-row>
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2">Empresa Pagadora</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="estructura" id="estructura" v-model="enterprise">
            <option disabled value="0">Selecciona empresa</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="nomarea">Nombre de área</label>
        </v-col>
        <v-col cols="12" sm="4" class="py-2 com">
          <input
            type="text"
            id="nomarea"
            name="nomarea"
            class="px-3"
            style="width: 80% !important"
            v-model="nombreArea"
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="corto">Nombre corto</label>
        </v-col>
        <v-col cols="12" sm="4" class="py-2 com">
          <input
            type="text"
            id="corto"
            name="corto"
            class="px-3"
            style="width: 80% !important"
            v-model="nombreCorto"
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Nivel de Áreas</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="level" id="level" v-model="level">
            <option disabled value="0">Seleccione nivel</option>
            <option
              v-for="level in niveles"
              :key="level.id"
              v-bind:value="level.id"
            >
              {{ level.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="pa-0">¿Área a la que reporta?</v-col>
        <v-col cols="12" sm="4" class="pa-0 selector">
          <select name="estructura" id="estructura" v-model="area">
            <option disabled value="0">Selecciona area</option>
            <option v-for="area in areas" :key="area.id" v-bind:value="area.id">
              {{ area.nombre }}
            </option>
          </select>
        </v-col>
        <v-col>
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validar()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>

    <!--Error-->
    <v-dialog v-model="error" width="380">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ titulo }}</span>
        </v-card-title>
        <v-card-text>
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "6-N",
      show: false,
      error: false,
      errors: [],
      estructura: 0,
      structure: [
        {
          id: 1,
          nombre: "Empresa Comercial",
        },
        {
          id: 2,
          nombre: "Empresa Pagadora",
        },
      ],
      respuesta: "",
      titulo: "",
      nivel: 0,
      niveles: [],
      carga: 0,
      cargas: [
        {
          id: 1,
          nombre: "Manual",
        },
        {
          id: 2,
          nombre: "Automatica",
        },
      ],
      enterprise: 0,
      enterprises: [],
      catalogo: true,
      lista: false,
      area: 0,
      nombreArea: "",
      nombreCorto: "",
      nombreArchivo: "",
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    validacion() {
      this.errors = [];
      console.log("empr" + this.estructura + "car" + this.carga);
      if (this.estructura == 0 || this.carga == 0) {
        this.errors.push(
          "Debe especificar la estructura organizacional y/o el tipo de carga"
        );
        this.respuesta = "Catálogo de áreas";
        this.error = true;
      }
      //Carga automatica
      if (this.estructura == 1 && this.carga == 2) {
        this.$router.push("/employeesList");
      }
      if (this.estructura == 1 && this.carga == 1) {
        this.$router.push("/addEmployee");
      }
      //carga manual
      if (this.errors.length == 0) {
        this.catalogo = false;
        return (this.lista = true);
      }
    },
    regresar() {
      this.lista = false;
      this.catalogo = true;
    },
    validar() {
      this.errors = [];
      console.log("Validacion datos de empleado");
      this.guardarEmpleado();
    },
    guardarEmpleado() {
      console.log("llego a api para guardar Empleado");
      this.$router.push("/employeesList");
    },
    previewFiles(event) {
      console.log(event);
      this.nombreArchivo = event.target.files[0].name;
      this.nombreArchivo.toLowerCase();
      var regex = new RegExp("(.*?).(xlsx|xls)$");

      if (!regex.test(this.nombreArchivo)) {
        this.nombreArchivo = "";
        this.titulo = "Archivo inválido";
        this.errors.push(
          "No se permite el archivo que ingreso favor de ingresar archivo con layout predeterminado."
        );
        this.error = true;
      } else {
        console.log("archivo bn");
        var selectedFile = event.target.files[0];
        //this.formData.append("file", selectedFile, selectedFile.name);
      }
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.show = false;
          this.enterprises = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
  },
  created() {
    this.nombre();
    this.listar();
    for (let index = 1; index <= 99; index++) {
      this.niveles.push({
        id: index,
        name: index.toString(),
      });
    }
  },
};
</script>